import { Head } from '@inertiajs/react';
import { Hack26PersonProfilePage } from '@/components/person-id/hack-26-person-card';
import { PersonProfilePage } from '@/components/person-id/person-card';
import type { PersonCardsShow } from '@/types';

// `/id/:slug` and `/<edition>/id/:slug`. The 26-co and 26-mx pages render the card with
// the edition lockup and its city above it; every other edition renders the plain one.
export default function Show({
  person,
  city,
  title,
  description,
}: PersonCardsShow) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      {city ? (
        <Hack26PersonProfilePage person={person} city={city} />
      ) : (
        <PersonProfilePage person={person} />
      )}
    </>
  );
}
